export const feeConstants = {
    GET_FEES_REQUEST: 'GET_FEES_REQUEST',
    GET_FEES_SUCCESS: 'GET_FEES_SUCCESS',
    GET_FEES_FAILURE: 'GET_FEES_FAILURE',
}